import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { Actions } from "../../../client/Actions";
import IconButton from "../../components/button/IconButton";
import ModalForm from "../../components/form/ModalForm";
import { useModels } from "../../helpers/models";
import { fields } from "./StoragePlaceInventoryFormConfig";

const StoragePlaceInventory = ({
                                   storagePlace,
                                   storagePlaceInventory,
                                   storagePlaceInventoryId,
                                   setLoader,
                                   setReload,
                                   reload
                               }) => {
    const [open, setOpen] = useState(false);
    const [openSource, setOpenSource] = useState(null);
    const [loadedSStoragePlaceInventory, setLoadedStoragePlaceInventory] = useState();
    const { t } = useTranslation();
    const models = useModels();

    const prepareStorageInventory = (storageInventory) => {
        storageInventory.storageInventoryDetails.forEach(details => {
            storageInventory[details.code] = details.result
        })

        return storageInventory;
    }

    const save = (data, onSaved) => {
        setLoader(true);

        const dto = {
            comment: data.comment,
            nextInventoryDate: data.nextInventoryDate,
            storageInventoryDetails: ["goodInsurance", "goodDescription", "good5s"].map((v) => ({
                code: v,
                result: data[v],
            })),
        };

        Actions.post(models.storagePlace.url + "/" + storagePlace.id + "/inventory", dto, () => {
            if (onSaved) {
                onSaved();
            }
        });


    };


    function loadStoragePlaceInventory() {
        if (storagePlaceInventoryId) {
            Actions.get(models.storagePlace.url + "/inventory/" + storagePlaceInventoryId, inventoryLoaded, () => {})
        }
    }

    function inventoryLoaded(data) {
        setLoadedStoragePlaceInventory(prepareStorageInventory(data))
    }

    useEffect(loadStoragePlaceInventory, [storagePlaceInventoryId])

    return (
        <>
            {storagePlace && (
                <IconButton
                    icon={"fa-boxes-stacked"}
                    tooltip={t("tooltips.review")}
                    variant={"outline-primary"}
                    onClick={() => {
                        setOpen(true);
                        setOpenSource("storagePlace");
                    }}
                />
            )}

            {loadedSStoragePlaceInventory && (
                <IconButton
                    icon={"fa-boxes-stacked"}
                    tooltip={t("tooltips.review")}
                    variant={"outline-primary"}
                    onClick={() => {
                        setOpen(true);
                        setOpenSource("storagePlaceInventory");
                    }}
                />
            )}


            {storagePlaceInventory &&
                <Badge
                    className={"outline-secondary font-max cursor-pointer"}
                    onClick={() => {
                        setOpen(true);
                        setOpenSource("storagePlaceInventory");
                    }}
                >
                    {storagePlaceInventory.date}
                </Badge>
            }

            {open && (
                <ModalForm
                    open={open}
                    setOpen={setOpen}
                    setLoader={setLoader}
                    initialData={openSource === "storagePlaceInventory" ? storagePlaceInventory || loadedSStoragePlaceInventory : undefined}
                    readOnly={openSource === "storagePlaceInventory" ? true : undefined}
                    size={"md"}
                    title={t("common.review")}
                    fields={fields(t)}
                    customSave={save}
                    onFinish={() => {
                        console.log("reload")
                        setReload(!reload)
                    }}
                />
            )}
        </>
    );
};

export default StoragePlaceInventory;
